import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "Ea"; // Ea stands for Exchange Activity
const EaActions = actionNameGenerator(domainPrefix);

export const fetchExchangeActivityType = EaActions("fetchExchangeActivity");
export const fetchEaSingleDataType = EaActions("fetchEaSingleData");
export const fetchEaSingleDataFailType = EaActions("fetchEaSingleDataFail")
export const fetchReDataType = EaActions("fetchReData");
export const setExchangeType = EaActions("setExchange");
export const cancelTxnScheduleType = EaActions("cancelTxnSchedule");
export const cancelReScheduleType = EaActions("cancelReSchedule"); 
export const setTabType = EaActions("setTab");
export const isLoadingType = EaActions("isLoading");
export const cancelExchangeDataType = EaActions("cancelExchangeData");
export const cancelReExchangeDataType = EaActions("cancelReExchangeData");

